var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('backlink'),_vm._v(" "),_c('h1',[_vm._v("Libellés de frais")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Suggestions proposées à la saisie d'une ligne de frais, avec leurs valeurs par défaut. La saisie libre reste possible : un libellé absent d'ici s'utilise tel quel.")]),_vm._v(" "),_c('AdminTable',{attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30deac72","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeeLabel/FeeLabelList.vue
// module id = 1033
// module chunks = 0